import React, { useState } from 'react';
import './Projects.css';
import { Data } from './Data';
import CollabVideo from '../../assets/collab-editor.mov';
import NpmPackage from '../../assets/node-package.png';

export const Projects = () => {
  const [projects, updateProjects] = useState(Data);
  return (
    <div className="projectsContainer">
      <div
        style={{
          width: '100%',
          padding: 24,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          columnGap: 24,
          marginTop: 72,
        }}
      >
        <div
          className="collab-project-description"
          style={{
            width: '40%',
            height: '100%',
            padding: 32,
          }}
        >
          <h1>Collaborative Editor</h1>
          <a
            href="https://collaborator-portal.vercel.app"
            target="_blank"
            style={{ marginLeft: 8 }}
          >
            https://collaborator-portal.vercel.app
          </a>

          <ul style={{ marginTop: 24 }}>
            <li>
              <p>
                Implemented a web portal that allow users to code in real time.
              </p>
            </li>
            <li>
              <p>
                Issues handled: conflict resolution, real time collaboration,
                version history.
              </p>
            </li>
            <li>
              <p>Tech used: Socket.io, NodeJS, React.</p>
            </li>
          </ul>
        </div>

        <video
          width="50%"
          loop
          muted
          autoPlay
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
          style={{
            pointerEvents: 'none',
            border: 'none',
            marginRight: 24,
          }}
        >
          <source src={CollabVideo} type="video/mp4"></source>
        </video>
      </div>

      <div
        style={{
          width: '100%',
          padding: 24,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'cente',
          columnGap: 24,
          marginTop: '10%',
        }}
      >
        <img
          src={NpmPackage}
          alt="Not available"
          style={{ width: '60%', marginLeft: 24 }}
        />

        <div
          className="collab-project-description"
          style={{
            width: '100%',
            height: '100%',
            padding: 32,
          }}
        >
          <h1>Node Package Publish</h1>
          <a
            href="https://collaborator-portal.vercel.app"
            target="_blank"
            style={{ marginLeft: 8 }}
          >
            https://www.npmjs.com/package/general-errors
          </a>

          <ul style={{ marginTop: 24 }}>
            <li>
              <p>
                Developed and published an open-source Typescript NPM package
                named general errors providing standardized error handling
                utilities.
              </p>
            </li>
            <li>
              <p>Tech used: NodeJs, Typescript</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
